import React from "react";
import { routes } from "./pages";
import {Mode} from './components'
import localData from "./localData";

function App() {
    const accessToken = 'fklsdsjafdjwoijee'

    const {angleUp} = localData.svgs

    return (
        <>
            <Mode/>
            <a href="/#home" className="scroll-top">{angleUp}</a>
            {routes(!!accessToken)}
        </>
    );
}

export default App;
